import _styled from "styled-components";
import styled from "styled-components";
import { GLYPHS, StyledIcon } from "../../Icon";
import { jsx as _jsx } from "react/jsx-runtime";
const StyledCheckboxIcon = styled(StyledIcon).attrs({
  styledWidth: "1em"
}).withConfig({
  displayName: "CheckboxIcon__StyledCheckboxIcon",
  componentId: "sc-lscvuy-0"
})(["top:0.125em;align-self:flex-start;position:relative;fill:currentColor;", " ", ""], props => !props.disabled && "\n    &:hover {\n      opacity: 0.6;\n    }\n  ", props => props.isSwitch && "\n    width: 28px;\n    &:hover {\n      opacity: 0.95;\n    }\n  ");
var _StyledStyledCheckboxIcon = styled(StyledCheckboxIcon).withConfig({
  displayName: "CheckboxIcon___StyledStyledCheckboxIcon",
  componentId: "sc-lscvuy-1"
})(["cursor:not-allowed;opacity:0.3;"]);
const CheckboxIcon = props => {
  const iconOn = props.isSwitch ? GLYPHS.switchOn : GLYPHS.checkboxOn;
  const iconOff = props.isSwitch ? GLYPHS.switchOff : GLYPHS.checkboxOff;
  if (props.isDisabled) {
    return /*#__PURE__*/_jsx(_StyledStyledCheckboxIcon, {
      glyph: props.isChecked ? iconOn : iconOff,
      disabled: true,
      isSwitch: props.isSwitch
    });
  } else {
    return /*#__PURE__*/_jsx(StyledCheckboxIcon, {
      isSwitch: props.isSwitch,
      glyph: props.isChecked ? iconOn : iconOff
    });
  }
};
export default CheckboxIcon;